import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { useParams } from "react-router";
import styled from "styled-components";
import Navbar from "../components/desktop/Navbar";
import BlueButton from "../components/desktop/BlueButton";
import firebase from 'firebase';

const firebaseConfig = {
    apiKey: 'AIzaSyB0-YwaTmfdi6p87ZyM-qghnlrNT7ZAeCA',
    authDomain: 'namaste-9d4ab.firebaseapp.com',
    databaseURL: 'https://namaste-9d4ab.firebaseio.com',
    projectId: 'namaste-9d4ab',
    storageBucket: 'namaste-9d4ab.appspot.com',
    messagingSenderId: '373196446500',
    appId: '1:373196446500:web:8fe1a8e0502861c00df1b1',
    measurementId: 'G-9SM64MNRYV',
  };


const Mobile = styled.div`
display: none;
@media only screen and (max-device-width: 480px) {
  display: flex;
  height: 100vh;
}
`;

const Desktop = styled.div`
display: none;
@media (min-device-width: 481px) {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}
`;

  const Container = styled.div`
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    align-content: center;
    height: 90vh;
    width: 100%;
    flex-direction: column;
    margin-top: 113px;
  `;

const Title = styled.div`
    text-align: center;
    color: #fff;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 20px;
    /* identical to box height, or 111% */
    letter-spacing: 0.1px;
    /* Colors / Text / Main */
    color: #FFFFFF;
    font-size: 18px;
    margin-top: 18px;
`;

const MembersTitle = styled.div`
    text-align: left;
    color: #fff;
    font-size: 16px;
    margin-top: 18px;
`;

const BackgroundImage = styled.div`
    height: 100%;
    width: 100%;
    filter: blur(200px);
    background-position: top;
    background-size: cover;
    position: absolute;
    z-index: -1;
    bottom: 625px;
`;

const Subtitle = styled.div`
    text-align: center;
    font-family: 'Inter';
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    /* or 21px */
    /* Colors/Text / Subtitle */
    color: #7A7F9E;
    margin-top: 8px;
    margin-bottom: 20px;
`;

const MemberList = styled.span`
    text-align: left;
    color: rgba(122, 127, 158, 1);
    font-size: 14px;
    margin-top: 4px;
    margin-right: 4px;
`;

const MemberListImages = styled.img`
    border-radius: 50%;
    border: 4px solid rgb(17,17,17);
    width: 30px;
    height: 30px;
    position: relative;
`;

const Members = ({members}: any) => {
    console.log(members)
    let data = Object.keys(members);
    if(data.length > 3) data = Object.keys(members).slice(0, 3)
    return data.map((item, index) => {
        return(
            <MemberListImages style={{right: index*7}} src={`https://be.namasteapis.com/api/v1/profile-image/${members[item].uid}`}/>
        )
    })
}

const MembersNames = ({members}: any) => {
  let data = Object.keys(members);
  console.log(data);
  if(data.length == 1) return <MemberList>{members[data[0]].name}</MemberList>
  if(data.length == 2) return <MemberList>{members[data[0]].name} & {members[data[1]].name}</MemberList>
  if(data.length == 3) return <MemberList>{members[data[0]].name}, {members[data[1]].name} & {members[data[2]].name}</MemberList>
  if(data.length > 3) return <MemberList>{members[data[0]].name}, {members[data[1]].name}, {members[data[2]].name} & {data.length - 3} others</MemberList>
}  
  
const DataBox = ({data}: any) => {
    const size = Object.keys(data.members).length;
    let show_extra_ball = false;
    if(size > 3) show_extra_ball = true;
    
    return(
        <Container>
          <div style={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center'}}>
           {data.image && <img src={data.image} style={{borderRadius: '50%', width: 72, height: 72}} />}
           {!data.image && <img src={"https://android-hosted-assets.s3.ap-south-1.amazonaws.com/glip_logo.png"} style={{borderRadius: '50%', width: 72, height: 72}} />}
            <Title>{data.title}</Title>
            <Subtitle>{data.title}</Subtitle>
          </div>
          <div style={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', width: '100%'}}>
          <div style={{marginTop: 115, display: 'flex', justifyContent: 'flex-start', flexDirection: 'row'}}>
            <Members members={data.members} />
            {show_extra_ball && <div style={{
              width: 30,
              height: 30,
              borderRadius: '50%',
              background: 'rgba(19, 22, 51, 1)',
              textAlign: 'center',
              color: '#4A7DFF',
              position: 'relative',
              right: 20,
              border: '4px solid rgb(17,17,17)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontFamily: 'Inter'
              }}>+{size - 3}</div>}
          </div>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'}}>
            <MembersNames members={data.members} />
          </div>
          <BlueButton style={{marginTop: 28, textAlign: 'center', width: '80%'}}  href={
            "https://play.google.com/store/apps/details?id=glip.gg&hl=en_IN&gl=US"
          }>Join Group</BlueButton>
          </div>
        </Container>
    )
}

export default function GroupPage(props) {
    const { groupId } = useParams();
    const [data, setData] = useState();

    useEffect(() => {
        // Initialize Firebase
        let otherApp = firebase.initializeApp(firebaseConfig);
        // firebase.analytics();
        // const app = firebase.app();
        window.otherApp = otherApp;
        console.log(window);
        console.log(window.otherApp);
        const docRef = window.otherApp
        .firestore()
        .collection('groups')
        .where('id', '==', groupId)

      console.log(docRef);
      docRef
        .get()
        .then((doc: any) => {
          const groupList: any = [];
          const { docs } = doc;
          // console.log(doc.data())
          docs.map((item: any) => {
            console.log(item.data())
            setData(item.data());
            // groupList.push(item.data());
          });
        //   setGroups(groupList);
          return;
        })
        .catch((error: any) => {
          console.log('Error getting document:', error);
        });
      }, []);


  if (!data) {
    return <></>;
  }

  return (
    <>
      <Mobile>
        <BackgroundImage 
          style={{
            backgroundImage: data.image ? `url('${data.image}')` : "url('https://cdn-m.namasteapis.com/27788/profile/1619591859741image.jpg')"}}
        />      
        <DataBox data={data}/>
      </Mobile>
      <Desktop>
        <Navbar />
        <DataBox data={data} />
      </Desktop>
    </>
  );
}

